import { useCallback, useMemo } from 'react'
import { generateClient } from 'aws-amplify/api'

import {
  getHighProfileIncomes as getHighProfileIncomesQuery,
  getOtherIncomes as getOtherIncomesQuery,
} from '../graphql/queries'
import {
  addHighProfileIncome as addHighProfileIncomeMutation,
  addOtherIncome as addOtherIncomeMutation,
} from '../graphql/mutations'

export const useIncome = () => {
  const client = useMemo(() => generateClient(), [])
  const addHighProfileIncome = useCallback(
    async (
      offeringId,
      teamId,
      targetId,
      incomeYear,
      profit = null,
      agreedFee,
    ) => {
      return client.graphql({
        query: addHighProfileIncomeMutation,
        variables: {
          input: {
            offeringId,
            teamId,
            targetId,
            incomeType: 'HIGH',
            incomeYear,
            profit,
            agreedFee,
          },
        },
      })
    },
    [client],
  )

  const addOtherIncome = useCallback(
    async (
      offeringId,
      teamId,
      incomeYear,
      numAsClients = null,
      numTsClients = null,
      numCsClients = null,
      asProfit = null,
      tsProfit = null,
      csProfit = null,
      profit,
    ) => {
      return client.graphql({
        query: addOtherIncomeMutation,
        variables: {
          input: {
            offeringId,
            teamId,
            incomeType: 'OTHER',
            incomeYear,
            numAsClients,
            numTsClients,
            numCsClients,
            asProfit,
            tsProfit,
            csProfit,
            profit,
          },
        },
      })
    },
    [client],
  )

  const getHighProfileIncomesByTeamId = useCallback(
    async (userId) => {
      return client.graphql({
        query: getHighProfileIncomesQuery,
        variables: {
          teamId: userId,
          incomeType: 'HIGH',
        },
      })
    },
    [client],
  )

  const getHighProfileIncomeByYear = useCallback(
    async (userId, incomeYear) => {
      return client.graphql({
        query: getHighProfileIncomesQuery,
        variables: {
          teamId: userId,
          incomeType: 'HIGH',
          incomeYear,
        },
      })
    },
    [client],
  )

  const getOtherIncomesByTeamId = useCallback(
    async (userId) => {
      return client.graphql({
        query: getOtherIncomesQuery,
        variables: {
          teamId: userId,
          incomeType: 'OTHER',
        },
      })
    },
    [client],
  )

  const getOtherIncomeByYear = useCallback(
    async (userId, incomeYear) => {
      return client.graphql({
        query: getOtherIncomesQuery,
        variables: {
          teamId: userId,
          incomeType: 'OTHER',
          incomeYear,
        },
      })
    },
    [client],
  )

  return {
    addHighProfileIncome,
    addOtherIncome,
    getHighProfileIncomeByYear,
    getOtherIncomeByYear,
    getHighProfileIncomesByTeamId,
    getOtherIncomesByTeamId,
  }
}
